import { render, staticRenderFns } from "./card-cfm.vue?vue&type=template&id=b8e43e48&scoped=true"
import script from "./card-cfm.vue?vue&type=script&lang=js"
export * from "./card-cfm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e43e48",
  null
  
)

export default component.exports